import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FormIOModel } from '../models/formio.model';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import {
  RecurringPayment,
  RecurringPaymentConfig,
} from '../models/recurring.model';
import { developmentConfig } from 'src/environments/merchant';
@Injectable({
  providedIn: 'root',
})
export class FormIoBuilderService {
  private baseRoute: string;
  private _selectedRow: Subject<any> = new Subject<any>();
  private _selectedRow$ = this._selectedRow.asObservable();
  selectedRow: any;

  constructor(private httpClient: HttpClient) {
    this.baseRoute = environment.formbuilderAPIUrlRoot;
  }

  getAllFormByMerchant(merchantName: string = '') {
    merchantName = this.handleBusinessName();
    return this.httpClient.get(`${this.baseRoute}/getallforms/${merchantName}`);
  }

  getAllDataFormio<T>(
    merchantName: string = '',
    module: string
  ): Observable<T> {
    merchantName = this.handleBusinessName();
    return this.httpClient.get<T>(
      `${environment.formbuilderAPIUrlRoot}/getalldatawithforminfo/${merchantName}?module=${module}`
    );
  }

  getAllDataFormioId<T>(
    merchantName: string = '',
    formId: string = ''
  ): Observable<T> {
    merchantName = this.handleBusinessName();
    return this.httpClient.get<T>(
      `${environment.formbuilderAPIUrlRoot}/getalldatawithforminfo/${merchantName}/${formId}`
    );
  }

  getDataFormioId(
    merchantName: string = '',
    formId: string = ''
  ): Observable<HttpResponse<Blob>> {
    merchantName = this.handleBusinessName();
    return this.httpClient.get<Blob>(
      `${environment.formbuilderAPIUrlRoot}/getformiodatacsv/${merchantName}/${formId}`,
      { observe: 'response', responseType: 'arraybuffer' as 'json' }
    );
  }

  deleteFormioData(id: string, userId: number) {
    return this.httpClient.delete(
      `${environment.formbuilderAPIUrlRoot}/deletedata/${id}/${userId}`
    );
  }

  getAllFormByModule(merchantName: string = '', module: string = '') {
    merchantName = this.handleBusinessName();
    return this.httpClient.get(
      `${this.baseRoute}/getforms/${merchantName}/${module}`
    );
  }

  saveForm(formData: FormIOModel) {
    formData.BusinessName = this.handleBusinessName();
    console.log(formData);
    return this.httpClient.post(`${this.baseRoute}/saveform`, formData);
  }

  updateForm(formData: FormIOModel) {
    return this.httpClient.put(
      `${this.baseRoute}/updateform/${formData.id}`,
      formData
    );
  }

  getForm(id: string) {
    return this.httpClient.get(`${this.baseRoute}/getform/${id}`);
  }

  deleteForm(id: string) {
    var merchantName = this.handleBusinessName();
    return this.httpClient.delete(
      `${this.baseRoute}/deleteform/${merchantName}/${id}`
    );
  }

  saveRecurringPayment(payload: RecurringPayment) {
    return this.httpClient.post(
      `${environment.recurringPaymentAPIRoot}/saverecurringpaymentformio`,
      payload
    );
  }

  saveRecurringInvoicePayment(payload: RecurringPayment) {
    return this.httpClient.post(
      `${environment.recurringInvoiceAPIRoot}/saverecurringinvoiceformio`,
      payload
    );
  }

  cancelRecurringPayment<T>(id: string, userId: number): Observable<T> {
    return this.httpClient.post<T>(
      `${environment.recurringPaymentAPIRoot}/cancelrecurringpaymentbyinvoicenumber/${id}/${userId}`,
      {}
    );
  }

  getRecurringConfigById(id: number) {
    return this.httpClient.get(
      `${environment.recurringPaymentAPIRoot}/getformioconfigurationbyid/${id}`
    );
  }

  getRecurringConfigByFormId(id: string) {
    return this.httpClient.get(
      `${environment.recurringPaymentAPIRoot}/getformioconfigurationsbyformid/${id}`
    );
  }

  upsertRecurringConfig(payload: RecurringPaymentConfig) {
    return this.httpClient.post(
      `${environment.recurringPaymentAPIRoot}/upsertformiorecurringpaymentconfiguration/`,
      payload
    );
  }

  deleteRecurringConfiguration(id: number, userId: any) {
    return this.httpClient.delete(
      `${environment.recurringPaymentAPIRoot}/deleteformioconfigurationbyid/${id}/${userId}`
    );
  }

  duplicateFormData(
    sourceFormId: string,
    destinationFormId: string,
    userId: any
  ) {
    return this.httpClient.post(
      `${this.baseRoute}/duplicateformio/${sourceFormId}/${destinationFormId}/${userId}`,
      []
    );
  }

  postUserDataEmbedForm<T>(userData: Object): Observable<T> {
    return this.httpClient.post<T>(
      `${environment.formbuilderAPIUrlRoot}/savedata`,
      userData
    );
  }

  sendPaymentFormNotification<T>(userData: Object): Observable<T> {
    return this.httpClient.post<T>(
      `${environment.formbuilderAPIUrlRoot}/sendformionotification`,
      userData
    );
  }

  exportEntryReportCsv(payload: any): Observable<HttpResponse<Blob>> {
    return this.httpClient.post<Blob>(
      `${environment.formbuilderAPIUrlRoot}/export`,
      payload,
      { observe: 'response', responseType: 'arraybuffer' as 'json' }
    );
  }

  getRecurringPaymentFormsList<T>(payload: Object): Observable<T> {
    return this.httpClient.post<T>(
      `${environment.formbuilderAPIUrlRoot}/getrecurringpaymentslist`,
      payload
    );
  }

  getFetchLocationsUrl() {
    return environment.apiRoot + 'api/account/location/getinfo';
  }

  getFetchRecurringPaymentsUrl(formId: string) {
    return `${environment.recurringPaymentAPIRoot}/getformioconfigurationsbyformid/${formId}`;
  }

  //@TODO : Move to a more generic class
  public handleBusinessName() {
    let merchantName = '';
    let subDomain = window.location.origin.split('.')[0]; //WHERE [0] IS http(s)://subdomainName

    if (
      subDomain.indexOf('http://localhost') > -1 ||
      subDomain.indexOf('http://127') > -1
    ) {
      merchantName = developmentConfig.merchant;
    } else {
      merchantName = subDomain.replace(/^https:/, '').replace('//', '');
      merchantName = merchantName.replace(/^http:/, '').replace('//', '');
    }
    return merchantName;
  }

  getSelectedRow(): Observable<any> {
    return this._selectedRow$;
  }

  setSelectedRow(row: any) {
    this.selectedRow = row;
    this._selectedRow.next(row);
  }

  getDisplayValue(component: any, value: any): string | Object {
    if (
      component?.type === 'select' &&
      component.data &&
      component.data.values
    ) {
      // Dropdown
      if (component.multiple === true) {
        // Multiple values
        const newValues: string[] = [];
        const splittedValue: string[] = value.split(',');

        splittedValue.forEach((optionValue) => {
          const option = component.data.values.find(
            (opt: any) => opt.value === optionValue
          );
          const foundOptionValue: string = option ? option.label : optionValue;
          newValues.push(foundOptionValue);
        });

        return newValues.join(',');
      } else {
        // Single value
        const option = component.data.values.find(
          (opt: any) => opt.value === value
        );
        return option ? option.label : value;
      }
    } else if (component?.type === 'radio' && component.values) {
      // radiobutton
      const option = component.values.find((opt: any) => opt.value === value);
      return option ? option.label : value;
    } else if (component?.type === 'selectboxes' && component.values) {
      // select boxes
      const newValue: Object = {};
      Object.keys(value).forEach((key) => {
        const option = component.values.find((opt: any) => opt.value === key);
        const newKey: string = option ? option.label : value;
        newValue[newKey] = value[key];
      });

      return newValue;
    }

    // If none of the types, return original value
    return value;
  }
}
